import React from 'react'
import Cover from './Cover'
import Vision from './Vision'
import UpComingEvns from './UpComingEvns'
import HomeMems from './HomeMems'
import ContactUs from './ContactUs'
import Counter from './Counter'
import CardContainer from './CardContainer'
import FacultyTest from './FacultyTest'

/* Home Landing Page */

function Home() {
  return (
    <div className='mt-[4.5rem] md:mt-[4.4rem]'>
      {/* <div className="marquee bg-gradient-to-r from-[#FD9980] to-[#F8D1C6] text-black">
        <a className='marquee-content text-base md:text-lg py-1 md:pt-0 font-bold' href='https://wcc6.pages.dev/' target='_blank' rel="noreferrer">
          🚀 WCC 6.0 Registrations are Now Open! Join WCC!
        </a>
      </div> */}
      <div>
        <Cover />
      </div>
      <Vision />
      <UpComingEvns />

      <HomeMems />
      <h2 className="text-white font-bold md:text-xl lg:text-2xl mt-[30px]" >Let them speak for us!</h2>
      <FacultyTest />

      <Counter />
      <h2 className="text-white font-bold md:text-xl lg:text-2xl">Projects at ACM VNRVJIET</h2>

      <CardContainer />
      <div id="ctus">

        <ContactUs />
      </div>

    </div >
  )
}

export default Home